import { render, staticRenderFns } from "./PlayerStats.vue?vue&type=template&id=5595e5f2&scoped=true&"
import script from "./PlayerStats.vue?vue&type=script&lang=js&"
export * from "./PlayerStats.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStats.vue?vue&type=style&index=0&id=5595e5f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5595e5f2",
  null
  
)

export default component.exports